// Tenant types for the `academies` collection. Every existing tenant predates
// this field, so it must always be read with a default — never written back
// as a migration — see ACADEMY_TYPE_ACADEMY below and the PLYRMATCH design
// notes for why. An 'agency' tenant (e.g. PLYRMATCH) recruits/registers
// players on behalf of partner academies/clubs/colleges rather than running
// its own Academy Portal — see AuthContext's academyType/isAgencyTenant.
export const ACADEMY_TYPE_ACADEMY = 'academy';
export const ACADEMY_TYPE_AGENCY = 'agency';

export const ACADEMY_TYPES = [ACADEMY_TYPE_ACADEMY, ACADEMY_TYPE_AGENCY];

// Undefined/missing `type` (every tenant created before this field existed)
// reads as a normal academy — this is the one rule that keeps this feature
// from ever touching an existing tenant's data.
export function normalizeAcademyType(type) {
  return type === ACADEMY_TYPE_AGENCY ? ACADEMY_TYPE_AGENCY : ACADEMY_TYPE_ACADEMY;
}

export function isAgencyType(type) {
  return normalizeAcademyType(type) === ACADEMY_TYPE_AGENCY;
}
